import CheckedCircleIcon from 'components/atoms/icons/checked-cirle';
import ChevronRightIcon from 'components/atoms/icons/chevronRight';
import colors from 'assets/styles/colors';
import { getReadingTypeLabel } from 'infrastructure/functions';

import { ProgressBar } from './progress';
import s from './styles.module.scss';

import type { IRpmPatientFormActivity, TCompletedTemplate } from '../types';
import type { FC } from 'react';

interface IProgressItemProps {
  clamped: number;
  total: number;
}

const ProgressItem = ({ clamped, total }: IProgressItemProps) => {
  return (
    <div className={s['template-list-item-wrapper']}>
      <div className={s['template-progress-list-item']}>
        <p>Assessments to Fill Out</p>
        <ProgressBar clamped={clamped} total={total} />
      </div>
    </div>
  );
};

interface ItemProps {
  completed: boolean;
  name: string;
  onClick: () => void;
}
const Item = ({ completed, name, onClick }: ItemProps) => {
  const checkBlock = completed ? (
    <CheckedCircleIcon />
  ) : (
    <div className={s.circle} />
  );
  return (
    <div
      className={s['template-list-item-wrapper']}
      data-hover
      onClick={onClick}
    >
      <div className={s['template-list-item']}>
        {checkBlock}
        <p>{name}</p>
        <ChevronRightIcon
          color={colors.textColor}
          style={{ marginLeft: 'auto' }}
        />
      </div>
    </div>
  );
};

interface TemplateListProps {
  data: IRpmPatientFormActivity[];
  completedTemplates: TCompletedTemplate[];
  setCurrentReadingType: (item: IRpmPatientFormActivity | null) => void;
  disable: boolean;
}

const TemplateList: FC<TemplateListProps> = ({
  data,
  completedTemplates,
  disable,
  setCurrentReadingType,
}) => {
  const total = data.length;
  const clamped = completedTemplates.filter((item) => item?.completed).length;

  return (
    <div className={s['template-list-wrapper']}>
      <ProgressItem clamped={clamped} total={total} />
      <br />
      {data.map((item) => {
        const isCompleted = completedTemplates.some(
          (ct) =>
            ct.completed &&
            ct.readingType === item.readingType &&
            ct.globalStatus === item.globalStatus,
        );

        return (
          <Item
            key={item.dateTime}
            name={getReadingTypeLabel(item.readingType)}
            completed={isCompleted}
            onClick={() => {
              if (!disable) setCurrentReadingType(item);
            }}
          />
        );
      })}
    </div>
  );
};
export default TemplateList;
